<template>
  <div>
    <div ref="yearContainer" id="yearContainer" class="flex items-center gap-2">
      <span v-if="isPrint" class="print-input mt-2" style="max-width: 100px;">{{form.year}}</span>
      <vs-input v-else type="number" :readonly="board.readonly || !!postId" v-model="form.year" style="width: 100px" />
      <p>년</p>
    </div>

    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="{ ...this.board, readonly: board.readonly || !!postId }" :is-print="isPrint" @selectField="selectField" :use-tab-codes="['medical']"/>


    <div class="">
      <div class="writeGridContainer">
        <div>
          <div>점검기간</div>
          <span v-if="isPrint" class="print-input"> {{form.inputA_1}} - {{form.inputA_2}} </span>
          <div v-else class="flex flex-1 items-center">
            <date-selector class="w-full" v-model="form.inputA_1" :readonly="board.readonly"/>
            <div class="ml-4 mr-4">~</div>
            <date-selector class="w-full" v-model="form.inputA_2" :readonly="board.readonly"/>
          </div>
        </div>
        <div class="writeGridLineItem">
          <span>점검내용</span>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_3 }} </span>
          <ml-input v-else v-model="form.inputA_3" :readonly="board.readonly" placeholder="중대재해처벌법 시행에 따른 안전관리 의무이행 사항 자체점검"/>
        </div>
        <div class="writeGridLineItem">
          <span>총평</span>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_4 }} </span>
          <ml-input v-else v-model="form.inputA_4" :readonly="board.readonly" placeholder="전반적인 안전관리 사항, 이행점검 시 중요사항 및 애로사항 중심으로 기재"/>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>시설개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>①시설명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <ml-input v-else :readonly="true" v-model="form.inputB_1" />
        </div>
        <div>
          <div>②주소</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <ml-input v-else :readonly="true" v-model="form.inputB_2" />
        </div>
        <div>
          <div>③규모</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3" placeholder="연면적"/>
        </div>

        <div>
          <div>④대상법령</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_4 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" placeholder="실내공기질관리법 (시설물 안전법 1,2,3종)"/>
        </div>
        <div>
          <div>⑤시설종류</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_5 }} </span>
          <ml-input v-else :readonly="true" v-model="form.inputB_5" />
        </div>
        <div>
          <div>⑥관리형태</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_6 }} </span>
          <ml-input v-else :readonly="true" v-model="form.inputB_6" />
        </div>

        <div>
          <div>⑥위탁시설-위탁부서</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_7 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_7" />
        </div>
        <div>
          <div>⑥위탁시설-위탁기간</div>
          <span v-if="isPrint" class="print-input"> {{form.inputB_8}} - {{form.inputB_9}} </span>
          <div v-else class="flex flex-1 items-center">
            <date-selector class="w-full" v-model="form.inputB_8" :readonly="board.readonly"/>
            <div class="ml-4 mr-4">~</div>
            <date-selector class="w-full" v-model="form.inputB_9" :readonly="board.readonly"/>
          </div>
        </div>

        <div/>
        <div>
          <div>⑦수탁현황-기관명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_10 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_10" />
        </div>
        <div>
          <div>⑦수탁현황-수탁비용</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_11 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_11" placeholder="00백만원/독립채산제"/>
        </div>
      </div>
      <span style="color: #7E72F2;">※ ⑥, ⑦번 항목은 위탁시설만 기재</span>
    </div>

    <!-- 구분 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 구분</h5>

      <div class="grid grid-cols-6">
        <div v-for="_구분 in ['상반기', '하반기']" :key="`구분_${_구분}`" class="col-span-1">
          <PrintRadio v-if="isPrint || board.readonly || !!postId" :label="_구분" :value="form.구분 === _구분" class="justify-center" />
          <vs-radio v-else v-model="form.구분" :vs-value="_구분" :disabled="board.readonly">{{ _구분 }}</vs-radio>
        </div>
      </div>
    </div>

    <!--    안전관리 추진현황-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 안전관리 추진현황</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-4 gap-x-6 gap-y-4 mt-4">
      <div v-for="_title in type1Title" :key="`checkbox_type1_${_title}`" class="col-span-1 flex items-center">
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div v-if="form.type1Checked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
          <span class="flex-1">
            {{ _title }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="form.type1Checked" :vs-value="_title">{{ _title }}</vs-checkbox>
          </span>
        </div>
      </div>
    </div>

    <!--    관리개선 및 보완사항-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 관리개선 및 보완사항</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-4 gap-x-6 gap-y-4 mt-4">
      <div v-for="_title in type2Title" :key="`checkbox_type2_${_title}`" class="col-span-1 flex items-center">
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div v-if="form.type2Checked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
          <span class="flex-1">
            {{ _title }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="form.type2Checked" :vs-value="_title">{{ _title }}</vs-checkbox>
          </span>
        </div>
      </div>
    </div>

    <!-- 의무이행사항 점검결과 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 의무이행사항 점검결과</h5>
      <div class="grid grid-cols-4 gap-x-6 gap-y-4 mt-4">
        <div v-for="(_title, _title_i) in getTitles" :key="`checkbox_inspect_${_title}`" class="col-span-1 flex items-center">
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div v-if="form.inspectChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
              {{ _title }}
            </span>
          </div>
          <div v-else>
            <span class="flex">
              <vs-checkbox v-model="form.inspectChecked" :vs-value="_title">{{ _title }}</vs-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 안전예산 집행내역 -->
    <div class="mt-28px" v-show="form.type1Checked.includes('안전예산 집행내역')">
      <h5 class="mb-4"><i class="dot"></i>안전예산 집행내역</h5>
      <table class="mb-4">
        <thead>
        <tr>
          <th>구분</th>
          <th>편성액</th>
          <th>집행액</th>
          <th>잔액</th>
          <th>추가소요액</th>
          <th>집행률</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(value, key) in form.집행내역" :key="`집행내역_${key}`">
          <th>{{ key }}</th>
          <td>
            <span v-if="isPrint" class="print-input"> {{ value.편성액 }} </span>
            <comma-input v-else :readonly="board.readonly || (!EnableSave && !postId)" v-model="value.편성액" @input="inputNumber(key)" class="w-full" />
          </td>
          <td>
            <span v-if="isPrint" class="print-input"> {{ value.집행액 }} </span>
            <comma-input v-else :readonly="board.readonly || (!EnableSave && !postId)" v-model="value.집행액" @input="inputNumber(key)" class="w-full" />
          </td>
          <td>
            <span v-if="isPrint" class="print-input"> {{ value.잔액 }} </span>
            <comma-input v-else readonly :value="value.잔액" class="w-full" />
          </td>
          <td>
            <span v-if="isPrint" class="print-input"> {{ value.추가소요액 }} </span>
            <comma-input v-else :readonly="board.readonly || (!EnableSave && !postId)" v-model="value.추가소요액" @input="inputNumber(key)" class="w-full" />
          </td>
          <td>
            <span v-if="isPrint" class="print-input"> {{ value.집행률 }} </span>
            <ml-input v-else readonly :value="value.집행률" class="w-full" />
          </td>
        </tr>
        <tr>
          <th>합계</th>
          <td>
            <span v-if="isPrint" class="print-input"> {{ form.합계.편성액 }} </span>
            <comma-input v-else readonly :value="form.합계.편성액" class="w-full" />
          </td>
          <td>
            <span v-if="isPrint" class="print-input"> {{ form.합계.집행액 }} </span>
            <comma-input v-else readonly :value="form.합계.집행액" class="w-full" />
          </td>
          <td>
            <span v-if="isPrint" class="print-input"> {{ form.합계.잔액 }} </span>
            <comma-input v-else readonly :value="form.합계.잔액" class="w-full" />
          </td>
          <td>
            <span v-if="isPrint" class="print-input"> {{ form.합계.추가소요액 }} </span>
            <comma-input v-else readonly :value="form.합계.추가소요액" class="w-full" />
          </td>
          <td>
            <span v-if="isPrint" class="print-input"> {{ form.합계.집행률 }} </span>
            <ml-input v-else readonly :value="form.합계.집행률" class="w-full" />
          </td>
        </tr>
        </tbody>
      </table>
      <div style="font-size: 14px; font-weight: 400; color: #7e72f2" class="mb-4">
        * 직접관리 시설은 안전관리를 위해 채용한 기간제, 일시사역 인력(공무원·공무직인건비 제외)의 인건비만 기재, 위탁관리 시설은 안전관리 전체 인원의 인건비 기재<br />
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div class="textarea-label p-0">추가 소요액 확보계획</div>
          <span v-if="isPrint" class="print-input"> {{ form.추가소요액확보계획 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.추가소요액확보계획" placeholder="안전점검 추가소요액 2024년 제1회 추경예산으로 확보" />
        </div>
      </div>
    </div>

    <table-custom
      v-show="form.type1Checked.includes('안전인력 운용현황')"
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="안전인력 운용현황"
      :controls="false"
      :multiple="false"
      :tableData="[
        { id: 'cell1', title: '확보인원', type: 'number', placeholder: '숫자입력', width: '188px' },
        { id: 'cell2', title: '주요업무', type: 'text', placeholder: '실제 시설에서 수행하는 업무를 구체적으로 기재' },
        { id: 'cell3', title: '추가필요인력', type: 'number', placeholder: '숫자입력', width: '188px' },
        { id: 'cell4', title: '사유 및 추가확보 계획', type: 'text', placeholder: '소관시설물 증가에 따른 안전점검 업무증가로 조직 및 인사부서와 협의' },
      ]"
      v-model="form.안전인력_운용현황"
    />

    <div class="mt-28px" v-show="form.type1Checked.includes('안전점검 및 보수보강 등 유지관리 현황')">
      <h5 class="mb-4"><i class="dot"></i>안전점검 및 보수보강 등 유지관리 현황 <span style='font-size: 14px; color:#7E72F2;'>※ 대상자를 위탁운영하고 있을 경우</span></h5>
      <table-custom
        class="pt-0"
        :board="board"
        :is-print="isPrint"
        :title="'<span style=\'font-size: 16px;font-weight: 400;\'>- 정기점검</span>'"
        :title-type="'html'"
        :tableData="[
        { id: 'cell1', title: '관련법령', type: 'text', placeholder: '시설물안전법 제11조' },
        { id: 'cell2', title: '분야', type: 'text', placeholder: '건축정기안전점검' },
        { id: 'cell3', title: '점검(예정)일자', type: 'text', placeholder: '입력' },
        { id: 'cell4', title: '점검내용', type: 'text', placeholder: '건축물 구조, 균열 점검' },
        { id: 'cell5', title: '점검방법(금액)', type: 'text', placeholder: '자체/용역(예산00백만원)' },
      ]"
        v-model="form.유지관리_현황_정기점검"
      />
      <table-custom
        class="pt-0"
        :board="board"
        :is-print="isPrint"
        :title="'<span style=\'font-size: 16px;font-weight: 400;\'>- 수시점검(유지관리)</span>'"
        :title-type="'html'"
        :tableData="[
        { id: 'cell1', title: '관련법령', type: 'text', placeholder: '승강기안전관리법 제31조' },
        { id: 'cell2', title: '분야', type: 'text', placeholder: '승강기유지관리' },
        { id: 'cell3', title: '주기', type: 'text', placeholder: '월1회' },
        { id: 'cell4', title: '유지관리사항', type: 'text', placeholder: '승강기 수리 부품교체 등' },
      ]"
        v-model="form.유지관리_현황_수시점검"
      />
    </div>

    <table-custom
      v-show="form.type1Checked.includes('주요 유해위험 요인 발생 및 조치현황')"
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="주요 유해위험 요인 발생 및 조치현황"
      :tableData="[
        { id: 'cell1', title: '발생현황', type: 'text', placeholder: '00건물 난관파손' },
        { id: 'cell2', title: '확인경위', type: 'text', placeholder: '신고/점검', width: '188px' },
        { id: 'cell3', title: '조치사항', type: 'text', placeholder: '00~00까지 이용제한, 보수보강 공사진행(00천원)' },
        { id: 'cell4', title: '보고(권한대행)', type: 'text', placeholder: '여/부', width: '188px' },
      ]"
      v-model="form.주요유해위험요인발생및조치현황"
    />

    <table-custom
      v-show="form.type1Checked.includes('비상대피훈련 실시')"
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="비상대피훈련 실시"
      :tableData="[
        { id: 'cell1', title: '대상법령', type: 'text', placeholder: '중처법 시행령제10조 제7호' },
        { id: 'cell2', title: '시행여부', type: 'text', placeholder: '여/부(.00.00시행)', width: '188px' },
        { id: 'cell3', title: '조치계획', type: 'text', placeholder: '00.00월 까지 시행예정' },
      ]"
      v-model="form.비상대피훈련실시"
    />

    <table-custom
      v-show="form.type1Checked.includes('관계법령의 의무사항 이행현황')"
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      :title="'<i class=\'dot\'></i>관계법령의 의무사항 이행현황 <span style=\'font-size: 14px; color:#7E72F2;\'>※ 안전점검 기재 제외</span>'"
      :title-type="'html'"
      :tableData="[
        { id: 'cell1', title: '의무사항', type: 'text', placeholder: '전기안전관리법제11조에 따른 자가용전기설비 정기 검사, 전기안전관리법 제22조 전기안전관리자 선임 등' },
        { id: 'cell2', title: '이행여부', type: 'text', placeholder: '여/부', width: '188px' },
        { id: 'cell3', title: '개선계획', type: 'text', placeholder: '00.00까지 선임예정', width: '376px' },
      ]"
      v-model="form.관계법령의의무사항이행현황"
    />

    <table-custom
      v-show="form.type1Checked.includes('교육 이수현황')"
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="교육 이수현황"
      :tableData="[
        { id: 'target', title: '교육대상', type: 'text', placeholder: '소방안전관리자, 위험물관리자 등' },
        { id: 'take', title: '이수여부', type: 'radio', middle: true, radioItems: [{ value: '이수' }, { value: '미이수' }], width: '150px', },
        { id: 'plan', title: '이수일/이수계획', type: 'date', placeholder: '날짜선택' },
        { id: 'reason', title: '미이수 사유', type: 'customType', },
        { id: 'note', title: '비고', type: 'text', placeholder: '00.00까지 선임예정' },
      ]"
      v-model="form.교육이수현황"
    >
      <template #customType="{ trData, value, input }">
        <input v-if="!!trData && !!trData.take && trData.take === '미이수'" :readonly="board.readonly" class="w-full flex-1" :value="value" @input="(e) => input(e.target.value)" placeholder="위험물관리자 변경(선임 6개월이내 이수)" />
      </template>
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td v-if="!isPrint"></td>
          <td style="padding: 10px 15px;" colspan="5">
            <div class="flex" style="place-content: center;">
              <div class="mx-10" style="align-self: center;">합계</div>
              <comma-input readonly placeholder="자동입력" v-model="form.takeSum"  />
              <div class="mx-10" style="align-self: center;">이수자 수</div>
              <comma-input readonly placeholder="자동입력" v-model="form.taken" />
              <div class="mx-10" style="align-self: center;">미이수자 수</div>
              <comma-input readonly placeholder="자동입력" v-model="form.untaken"  />
            </div>
          </td>
        </tr>
      </template>
    </table-custom>

    <table-custom
      v-show="form.type2Checked.includes('의무사항 미이행 현황')"
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="의무사항 미이행 현황"
      :tableData="[
        { id: 'cell1', title: '관계법령', type: 'text', placeholder: '입력' },
        { id: 'cell2', title: '의무사항', type: 'text', placeholder: '입력' },
        { id: 'cell3', title: '미조치 사유', type: 'text', placeholder: '입력' },
        { id: 'cell4', title: '이행계획', type: 'text', placeholder: '입력' },
      ]"
      v-model="form.의무사항미이행현황"
    />

    <div class="mt-28px" v-show="form.type2Checked.includes('사고발생 현황')">
      <h5 class="mb-4"><i class="dot"></i>사고발생 현황</h5>
      <table class="mb-4">
        <tbody>
        <tr>
          <th>구분-피해현황</th>
          <th  style="border-right: none;">피해인원</th>
          <th style="border-left: none; border-right: none;">사고경위 및 조치</th>
          <th style="border-left: none; border-right: none;">비고</th>
        </tr>
        <tr v-for="cell in form.사고발생현황">
          <th>{{ cell.cell1 }}</th>
          <td style="border-right: none;">
            <p v-if="isPrint">{{ cell.cell2 }}</p>
            <ml-input v-else class="w-full" v-model="cell.cell2" :readonly="cell.cell1 === '계'" type="number" :min-value="0"/>
          </td>
          <td style="border-left: none; border-right: none;">
            <p v-if="isPrint">{{ cell.cell3 }}</p>
            <ml-input v-else class="w-full" v-model="cell.cell3" />
          </td>
          <td style="border-left: none; border-right: none;">
            <p v-if="isPrint">{{ cell.cell4 }}</p>
            <ml-input v-else class="w-full" v-model="cell.cell4" />
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-28px" v-show="form.type2Checked.includes('기타 개선 및 보완이 필요한 사항')">
      <h5 class="mb-4"><i class="dot"></i>기타 개선 및 보완이 필요한 사항</h5>
      <div class="w-full">
        <p v-if="isPrint">
          {{ form.기타개선및보완이필요한사항 }}
        </p>
        <ml-textarea class="m-0" :readonly="board.readonly" v-else rows="5" v-model="form.기타개선및보완이필요한사항" />
      </div>
    </div>

    <TableInspectMerge
      v-for="(item, itemIndex) in form.inspectList"
      :key="`inspect1_${item.title}_${itemIndex}`"
      v-show="form.inspectChecked.includes(item.title) && item.title === '의무이행사항 점검결과(직접관리 시설)'"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="item.title"
      :is-title-dot="item.isTitleDot"
      :tableHeaderTitle="item.tableHeaderTitle || '중대재해처벌법 의무이행 사항'"
      :tableHeaderCheck="item.tableHeaderCheck"
      :tableHeaderNote="item.tableHeaderNote"
      :footer="item.footer"
      v-model="item.list"
      class="mt-28px"
    />

    <h5 v-if="form.inspectChecked.includes('의무이행사항 점검결과(위탁운영 시설)')" class="mt-28px"><i class="dot"></i>의무이행사항 점검결과(위탁운영 시설)</h5>
    <TableInspectMerge
      v-for="(item, itemIndex) in form.inspectList"
      :key="`inspect2_${item.title}_${itemIndex}`"
      v-show="form.inspectChecked.includes(item.title) && item.title === '의무이행사항 점검결과(위탁운영 시설)'"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="item.subTitle"
      :is-title-dot="item.isTitleDot"
      :tableHeaderTitle="item.tableHeaderTitle || '중대재해처벌법 의무이행 사항'"
      :tableHeaderCheck="item.tableHeaderCheck"
      :tableHeaderNote="item.tableHeaderNote"
      :footer="item.footer"
      v-model="item.list"
      class="mt-3"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import HttpRequest from "@/util/HttpRequest";
import PrintRadio from "@/components/print/PrintRadio.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    PrintRadio,
    DateSelector,
    SignField,
    FileUploadModule,
    TableInspectMerge,
    FieldSelectModule,
    PhotoUploadGridModule,
    DisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      type1Title: ["안전예산 집행내역", "안전인력 운용현황", "안전점검 및 보수보강 등 유지관리 현황" , "주요 유해위험 요인 발생 및 조치현황", "비상대피훈련 실시", "관계법령의 의무사항 이행현황", "교육 이수현황"],
      type2Title: ["의무사항 미이행 현황", "사고발생 현황", "기타 개선 및 보완이 필요한 사항"],
      EnableSave: false,

      oldForm: {},
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: "",
        inputB_11: "",

        type1Checked: [],
        type2Checked: [],

        // 안전예산 집행내역
        year: new Date().getFullYear(),
        구분: "상반기",

        집행내역: {
          안전점검: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          보수보강: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          안전조치: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          인건비: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          기타: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
        },
        합계: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },

        추가소요액확보계획: "",
        // 안전인력 운용현황
        안전인력_운용현황: [{cell1:'', cell2:'', cell3: '', cell4: ''}],
        // 안전점검 및 보수보강 등 유지관리 현황
        유지관리_현황_정기점검: [],
        유지관리_현황_수시점검: [],
        주요유해위험요인발생및조치현황: [],
        비상대피훈련실시: [],
        관계법령의의무사항이행현황: [],
        교육이수현황: [],

        의무사항미이행현황:[],
        사고발생현황:[
          {cell1: '사망자', cell2: '', cell3: '', cell4: ''},
          {cell1: '부상자', cell2: '', cell3: '', cell4: ''},
          {cell1: '질병자', cell2: '', cell3: '', cell4: ''},
          {cell1: '계', cell2: '', cell3: '', cell4: ''},
        ],
        기타개선및보완이필요한사항: "",

        taken: 0,
        untaken: 0,
        takeSum: 0,

        inspectionTitle: "",
        inspectChecked: [],
        inspectList: inspectData,
      },
    };
  },
  computed: {
    getTitles() {
      const titleSet = new Set(this.form.inspectList.map((item) => item.title));
      return Array.from(titleSet);
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.board.list))];
    },
    boardId() {
      return this.$route.params.boardId;
    },
  },
  watch: {
    value: {
      deep: true,
      async handler(value) {
        // form 과 같은 데이터 인지 체크
        if (JSON.stringify(value) !== JSON.stringify(this.form)) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {

              if (key === "집행내역" && value[key] && value[key].length > 0) {
                const keys = Object.keys(value[key]);
                if (keys.indexOf("기타") === -1) {
                  value[key]["기타"] = { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 };
                }
              }

              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      deep: true,
      handler(value) {
        this.form.inspectionTitle = value.inspectChecked.join(" ");
        this.$emit("input", value);
      },
    },
    EnableSave: {
      immediate: true,
      handler(value) {
        if (value) this.$emit("EnableSave", value);
      },
    },
    "form.stdInfo.field_id": {
      immediate: true,
      handler(value) {
        this.loadListBoard();
      },
    },
    "form.year": {
      immediate: true,
      handler(value) {
        this.loadListBoard();
      },
    },
    "form.구분": {
      immediate: true,
      handler(value) {
        this.loadListBoard();
      },
    },
    "form.교육이수현황": {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.length !== 0) {
          this.form.taken = 0
          this.form.untaken = 0
          for(const item of this.form.교육이수현황) {
            if (item.take === '이수') {
              this.form.taken += 1
            } else if (item.take === '미이수') {
              this.form.untaken += 1
            }
          }
          this.form.takeSum = this.form.taken + this.form.untaken
        }
      },
    },
    "form.사고발생현황": {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.length !== 0) {
          let sum = 0;
          for (const item of value) {
            if (item.cell1 !== "계") {
              sum += Number(item.cell2);
            }
          }
          value[value.length - 1].cell2 = sum;
        }
      },
    },
  },
  created() {
    console.log("created", !!this.form.year && !!this.form.stdInfo.field_id && !!this.form.구분);
    this.EnableSave = !!this.form.year && !!this.form.stdInfo.field_id && !!this.form.구분;
    this.$emit("EnableSave", this.EnableSave);
  },
  mounted() {
    document.getElementById("yearContainer").remove();
    document.getElementById("print-label").appendChild(this.$refs.yearContainer);
  },
  methods: {
    inputNumber(key) {
      this.form.집행내역[key].잔액 = this.form.집행내역[key].편성액 - this.form.집행내역[key].집행액;
      if (this.form.집행내역[key].편성액 && this.form.집행내역[key].집행액) this.form.집행내역[key].집행률 = ((this.form.집행내역[key].집행액 * 100) / this.form.집행내역[key].편성액).toFixed(2);
      else this.form.집행내역[key].집행률 = 0.0;

      const 합계 = { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 };
      for (const key in this.form.집행내역) {
        합계.편성액 += Number(this.form.집행내역[key].편성액);
        합계.집행액 += Number(this.form.집행내역[key].집행액);
        합계.잔액 += Number(this.form.집행내역[key].잔액);
        합계.추가소요액 += Number(this.form.집행내역[key].추가소요액);
      }
      if (합계.편성액 && 합계.집행액) 합계.집행률 = ((합계.집행액 * 100) / 합계.편성액).toFixed(2);
      else 합계.집행률 = 0.0;
      this.form.합계 = 합계;
    },
    selectField(value) {
      this.oldForm = {};
      this.loadListBoard();
      this.inputField(value);
    },
    inputField(value) {
      const meta = value.meta? JSON.parse(value.meta):"";
      this.form.inputB_1 = value.field_name; // 시설명
      this.form.inputB_2 = value.address; // 주소
      // this.form.inputB_3 = `${value.scale1} ${value.scale2} ${value.scale3}`; // 규모
      this.form.inputB_5 = `${meta.cat1} > ${meta.cat2} > ${meta.cat3} > ${meta.classification}` // 시설종류
      this.form.inputB_6 = meta.관리방법? meta.관리방법 : ""; // 관리방법
    },
    async loadListBoard() {
      if (!this.form.stdInfo.field_id) return;

      // 기존에 로드한 데이터가 있으면 그냥 사용
      if (this.oldForm[`${this.form.year}_${this.form.구분}`]) {
        this.EnableSave = false;
        this.form = { ...this.form, 집행내역: this.oldForm[`${this.form.year}_${this.form.구분}`] };
        return;
      } else {
        this.EnableSave = true;
        this.form.집행내역 = {
          안전점검: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          보수보강: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          안전조치: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          인건비: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          기타: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
        };
        this.form.합계 = { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 };
      }

      const params = {
        projectId: this.projectId,
        page: 1,
        fieldId: this.form.stdInfo.field_id,
      };

      const conditions = [
        {
          key: "body.year",
          operator: "=",
          value: `${this.form.year}`,
        },
        {
          key: "body.구분",
          operator: "=",
          value: this.form.구분,
        },
      ];

      for (let i = 0, condition; (condition = conditions[i]); i++) {
        const keys = Object.keys(condition);
        for (const key of keys) {
          params[`conditions[${i}][${key}]`] = condition[key];
        }
      }

      HttpRequest.get(`/api/v1/board/post/${this.boardId}`, { params })
        .then((response) => {
          if (response.data.length < 1) {
            this.EnableSave = true;
          } else {
            this.EnableSave = false;

            const data = this.getContent(response.data[0]);
            if (data.집행내역) {
              const keys = Object.keys(data.집행내역);
              if (keys.indexOf("기타") === -1) {
                data.집행내역["기타"] = { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 };
              }
            }

            this.oldForm = { ...this.oldForm, [`${this.form.year}_${this.form.구분}`]: data.집행내역 };
            this.form.집행내역 = data.집행내역;
          }
        })
        .catch((err) => {});
    },

    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
input {
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 0.7rem !important;
  transition: all 0.3s ease;
  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 0.5rem;
  }

  th {
    height: 50px;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
    background-color: #f9f9f9;
  }
}
</style>
